/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 0233a18a04c57e53ad9a43fcc32cffd8 */

import { ConcreteRequest } from "relay-runtime";

export type EditUserPreferencesInput = {
    userId: string;
    shareActivities?: boolean | null | undefined;
    customOffers?: boolean | null | undefined;
    auctionMailOptin?: boolean | null | undefined;
    orderFeedbackMailOptin?: boolean | null | undefined;
    weeklyDigestMailOptin?: boolean | null | undefined;
    promotionalMailList?: boolean | null | undefined;
    favoriteSearchesMailList?: boolean | null | undefined;
    favoriteDealersMailList?: boolean | null | undefined;
    tradeMailList?: boolean | null | undefined;
    communicationPreferredLocale?: string | null | undefined;
    smsOptin?: boolean | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type editUserPreferencesMutationVariables = {
    input: EditUserPreferencesInput;
};
export type editUserPreferencesMutationResponse = {
    readonly editUserPreferences: {
        readonly user: {
            readonly preferences: {
                readonly shareActivities: boolean | null;
            } | null;
        } | null;
    } | null;
};
export type editUserPreferencesMutation = {
    readonly response: editUserPreferencesMutationResponse;
    readonly variables: editUserPreferencesMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "concreteType": "UserPreferences",
        "kind": "LinkedField",
        "name": "preferences",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shareActivities",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "editUserPreferencesMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "EditUserPreferencesPayload",
                    "kind": "LinkedField",
                    "name": "editUserPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutations",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "editUserPreferencesMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "EditUserPreferencesPayload",
                    "kind": "LinkedField",
                    "name": "editUserPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "ferrum/352.0.0-2022-02-11T14:31:47.735Z/editUserPreferencesMutation",
            "metadata": {},
            "name": "editUserPreferencesMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '9bca29cf5d7e68a73a05b1fed8dc91c4';
export default node;
